import script from "./AgentApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentApp.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__